import { assessmentTreatmentPlanApi } from "./assessmentTreatmentPlan";

export const clientReportServiceApi = assessmentTreatmentPlanApi.injectEndpoints({
  endpoints: (builder) => ({
    getTreatmentSummaryGoals: builder.query({
      query: ({ caseloadId, data, clientType }) => ({
        method: "POST",
        url: `/${clientType}/treatment-summary/${caseloadId}`,
        data
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["AssessmentStepGoals"]
    })
  })
})


export const {
  useGetTreatmentSummaryGoalsQuery,
  useLazyGetTreatmentSummaryGoalsQuery,
} = clientReportServiceApi